<template>
  <card class="card-user">
    <div slot="image" class="image">
      <img src="/img/Shopware_Logo_2016.svg" alt="..." />
    </div>
    <div>
      <div class="author">
        <a :href="'https://' + user.sw_url" target="_blank">
          <img class="avatar border-gray" :src="shopLogo" alt="..." />
          <h5 class="title">{{ user.sw_url }}</h5>
        </a>
        <p class="description">{{ user.sw_user }}</p>
      </div>
      <p class="description text-center">
        Shopware v.{{ apiVersion.version }}
        revision {{ apiVersion.revision }}<br /><br />
        <span
          v-if="apiVersion.version != 'no connection'"
          slot="header" class="badge badge-success">
            API Success
        </span>
        <span
          v-else
          slot="header" class="badge badge-warning">
            No API Success
        </span>
      </p>
    </div>

    <div>
      <a href="https://sw5-sandbox.com/custom/plugins/pluginDownloadZip.php">Get Plugin</a>
    </div>

    <div slot="footer" class="button-container">
      <n-button href="#" type="neutral" icon round size="lg">
        <i class="fab fa-facebook-square"></i>
      </n-button>
      <n-button href="#" type="neutral" icon round size="lg">
        <i class="fab fa-twitter"></i>
      </n-button>
      <n-button href="#" type="neutral" icon round size="lg">
        <i class="fab fa-google-plus-square"></i>
      </n-button>
    </div>
  </card>
</template>
<script>
export default {
  props: {
    user: Object,
  },
  data() {
    return {
      shopLogo: '',
      apiVersion: {
        version: '',
        revision: '',
      },
    };
  },

  created() {
    this.getApiVersion();
  },

  methods:{
    setShopLogo (val) {
      this.shopLogo = val
    },
    async getApiVersion() {
      await this.$store.dispatch("swapi/get", 'getApiVersion/param:null');
      this.apiVersion = await this.$store.getters["swapi/swapi"];
      this.apiVersion =  this.apiVersion.type.data.apiVersion.data;
      if (!this.apiVersion) {
        this.apiVersion = {
          version: 'no connection',
          revision: 'no connection', 
        }     
      }
      console.log('getApiVersion swapi: ', this.apiVersion);
    },
  },
};
</script>
<style>
</style>
